/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* Added by Jon N @ Shopify - July 13 2018 */
var sections = window.theme.sections;
 
var headerExtension = {
  init: function() {
    this.on('section_load', this._promiseHeaderSlideIn.bind(this));
  },
 
  _promiseHeaderSlideIn: function() {
    //override original function
  }
};
 
sections.extend('header-section', headerExtension);